import Quill from 'quill';
import Delta from 'quill-delta';

const BlockEmbed = Quill.import('blots/block/embed');
const Inline = Quill.import('blots/inline');

export class PageBreakBlot extends BlockEmbed {}
PageBreakBlot.blotName = 'pageBreak';
PageBreakBlot.tagName = 'div';
PageBreakBlot.className = 'ql-page-break';

export class CommentBlot extends Inline {
    static create(commentId) {
        const node = super.create();
        node.setAttribute('data-comment-id', commentId);
        return node;
    }

    static formats(node) {
        return node.getAttribute('data-comment-id') || true;
    }

    format(name, value) {
        if (name === 'comment' && value) {
            this.domNode.setAttribute('data-comment-id', value);
        } else {
            super.format(name, value);
        }
    }
}
CommentBlot.blotName = 'comment';
CommentBlot.tagName = 'span';
CommentBlot.className = 'ql-comment';

export const lineBreakMatcher = () => {
    const newDelta = new Delta();
    newDelta.insert({ break: '' });
    return newDelta;
};

export const templates = ['template 1', 'template 2'];

export const fonts = ['sans-serif', 'serif', 'monospace', 'times-new-roman', 'comic-sans'];

export const alignments = ['left', 'center', 'right', 'justify'];

export const people = [
    {
        id: '1',
        firstName: 'John',
        lastName: 'Doe',
    },
    {
        id: '2',
        firstName: 'Jane',
        lastName: 'Doe',
    },
    {
        id: '3',
        firstName: 'Alice',
        lastName: 'Smith',
    },
    {
        id: '4',
        firstName: 'Bob',
        lastName: 'Smith',
    },
];

/**
 * @returns {Delta} Modified Delta object
 */
export function insertImageIntoDelta(base64String, oldDelta) {
    return oldDelta.insert({ image: base64String });
}

/**
 * @returns {Delta} Modified Delta object
 */
export function insertNewLineIntoDelta(count, oldDelta) {
    return oldDelta.insert('\n'.repeat(count));
}

/**
 * @returns {Delta} Modified Delta object
 */
export function insertTitleIntoDelta(title, oldDelta) {
    return oldDelta
        .insert(title, {
            bold: true,
            size: '20px',
            italic: true,
        })
        .insert('\n', {
            align: 'center',
        });
}

/**
 * @returns {Delta} Modified Delta object
 */
export function insertSubTitleIntoDelta(subTitle, oldDelta) {
    return oldDelta.insert(subTitle, {
        bold: true,
        size: '16px',
    });
}

/**
 * @returns {Delta} Modified Delta object
 */
export function insertTableIntoDelta(columnsWidth, tableData, oldDelta) {
    const tableOperations = [
        {
            insert: '\n',
        },
    ];

    columnsWidth.forEach((width) => {
        tableOperations.push({
            attributes: {
                'table-col': {
                    width: width?.toString(),
                },
            },
            insert: '\n',
        });
    });

    tableData.forEach((row) => {
        const uniqueRowId = rowId();

        row.forEach((cell) => {
            tableOperations.push(
                {
                    insert: typeof cell === 'string' ? cell?.replace('#bold', '') : cell,
                    ...(typeof cell === 'string' &&
                        cell?.includes('#bold') && {
                            attributes: {
                                bold: true,
                            },
                        }),
                },
                {
                    attributes: {
                        colspan: '1',
                        row: uniqueRowId,
                        rowspan: '1',
                        'table-cell-line': {
                            cell: cellId(),
                            colspan: '1',
                            row: uniqueRowId,
                            rowspan: '1',
                        },
                    },
                    insert: '\n',
                }
            );
        });
    });

    tableOperations.push({
        insert: '\n',
    });

    const tableDelta = new Delta(tableOperations);
    return oldDelta.concat(tableDelta);
}

function rowId() {
    const id = Math.random().toString(36).slice(2, 6);
    return `row-${id}`;
}

function cellId() {
    const id = Math.random().toString(36).slice(2, 6);
    return `cell-${id}`;
}
